/**
 * Constants defined for checkout <-> tax Id entry interaction API.
 */
export const EVENT_TAX_ID_INIT = 'taxIdIFrameInitialized';
export const EVENT_TAX_ID_INIT_CONTEXT = 'initializeTaxIdIframeContext';
export const EVENT_TAX_ID_SAVE_SUCCESS = 'taxIdSaveSuccess';
export const EVENT_TAX_ID_SAVE_FAILURE = 'taxIdSaveFailure';
export const EVENT_TAX_ID_SET_HEIGHT = 'taxIdIFrameSetHeight';
